import { denormalize } from 'normalizr';
import { createSelector } from 'reselect';
import { channelSchema, conversation, conversations } from 'Schemas/schemas';

export const getEntities = state => state.entities?.webChat;

export const getConversationByIds = (entities, ids) => denormalize(ids, conversations, entities);

export const mergeBubbleChat = (entities, bubbles) => {
  const ids = [];
  const isMinimums = [];
  // eslint-disable-next-line no-unused-expressions
  bubbles?.map((bubble) => {
    ids.push(bubble.id);
    if (bubble.isMinimum) {
      isMinimums.push(bubble.id);
    }
    return null;
  });
  const groups = getConversationByIds(entities, ids);
  return groups?.map(group => ({ ...group, isMinimum: !!isMinimums.includes(group.id) }));
};

export const getBubblesChat = createSelector(
  [state => state.entities.webChat, state => state.webChat.commons.bubbles],
  mergeBubbleChat,
);

export const getConversationById = createSelector(
  [getEntities, (state, id) => id],
  (entities, id) => denormalize(id === -1 ? {} : id, conversation, entities),
);

export const getChannelById = createSelector(
  getEntities,
  entities => id => denormalize(id, channelSchema, entities),
);
